const editRoles = {
  en: {
    translation: {
      assigned_roles: "Assigned roles",
      OWNER: "Owner",
      ADMINISTRATOR: "Administrator",
      EDITOR: "Editor",
      OWNER_description:
        "The business owner can manage every aspect of the page: edit the information in every section, add and edit the photos (feature only available for Essential, Essential plus and Premium packages), respond to reviews, check statistics, add administrators and editors. The owner can not be removed.",
      ADMINISTRATOR_description:
        "The administrator can manage every aspect of the page: edit the information in every section, add and edit the photos (feature available only for Essential, Essential plus and Premium packages), respond to reviews, check statistics, add administrators and editors. The administrator can be removed by the owner.",
      EDITOR_description:
        "The editor can respond to reviews and hide photos considered inappropriate (this feature is only available for Essential, Essential plus and Premium packages). The editor can be removed by the administrator and the owner.",
      remove: "Remove",
      edit: "Edit",
      add_role: "Add role",
      insert_as: "Add",
      placeholder_autocomplete: "Write username",
      user_not_present: "User does not exist"
    }
  },
  it: {
    translation: {
      assigned_roles: "Ruoli assegnati",
      OWNER: "Proprietario",
      ADMINISTRATOR: "Amministratore",
      EDITOR: "Editor",
      OWNER_description:
        "Il proprietario dell'attività può gestire ogni aspetto della pagina: modificare le informazioni di tutte le sezioni, inserire e curare le foto (funzionalità prevista solo per i pacchetti Essential, Essential plus e Premium), rispondere alle recensioni ricevute, controllare le statistiche, aggiungere amministratori ed editor. Il ruolo di proprietario non può essere revocato.",
      ADMINISTRATOR_description:
        "L'amministratore può gestire ogni aspetto della pagina: modificare le informazioni di tutte le sezioni, inserire e curare le foto (funzionalità prevista solo per i pacchetti Essential, Essential plus e Premium), rispondere alle recensioni ricevute, controllare le statistiche e aggiungere amministratori ed editor. Il ruolo di amministratore può essere revocato dal proprietario.",
      EDITOR_description:
        "L'editor può rispondere alle recensioni e nascondere le foto ritenute non appropriate (quest'ultima funzionalità è attiva solo per i pacchetti Essential, Essential plus e Premium). Il ruolo di editor può essere revocato da amministratore e proprietario.",
      remove: "Rimuovi",
      edit: "Modifica",
      add_role: "Aggiungi collaboratore",
      insert_as: "Aggiungi",
      placeholder_autocomplete: "Scrivi l'username",
      user_not_present: "L'utente non esiste"
    }
  }
};

export default editRoles;
